import Vue from 'vue'
import Vuex from 'vuex'
import message from '@/store/modules/message'
import messagestatus from '@/store/modules/messagestatus'
import display from '@/store/modules/display'
import session from '@/store/modules/session'
import group from '@/store/modules/group'
import channel from '@/store/modules/channel'
import conversation from '@/store/modules/conversation'
import { Config } from '@/config'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    socket: {
      connection: null,
      qrConnection: null,
      baseUrl: process.env.VUE_APP_SOCKETBASEURL,
      qrUrl: process.env.VUE_APP_SOCKETQRURL,
      browserUuid: '',
      source: 'browser',
      url: '',
      protocol: 'specMessage',
      reconnectTimer: 1,
      reconnectTimeout: null,
      shouldReconnect: true,
      reconnectProgress: 2,
      maxReconnectTimer: 30
    },
    ien: true,
    contacts: [],
    theme: {},
    isFirstLoad: true,
    isConnected: true,
    token: ''
  },
  getters: {
    filteredContacts: state => {
      var contacts = state.contacts
      contacts.sort(function (a, b) {
        if (a.VisibleName < b.VisibleName) return -1
        if (a.VisibleName > b.VisibleName) return 1
        return 0
      })

      var filtered = contacts.filter(
        c => c.UserID !== state.session.user.UserID && c.CompanyStatus === 1 || state.session.user.CompanyID === c.CompanyID
      )

      return filtered
    },

    getUserById: state => id => {
      let selectedUser = state.contacts.find(contact => contact.UserID === id)
      if (selectedUser) {
        selectedUser.PhotoURL = selectedUser.PhotoURL ? selectedUser.PhotoURL : '/images/nophoto.png'
      }
      return selectedUser
    }
  },
  mutations: {
    toggleAudioRecorderState (state) {
      state.display.audioInputActive = !state.display.audioInputActive
    },

    setContacts (state, data) {
      state.contacts = data
    },

    setProfilePhoto (state, data) {
      state.session.user.PhotoURL = data
    }
  },

  actions: {
    toggleAudioRecorderState (context) {
      context.commit('toggleAudioRecorderState')
    },

    setContacts (context, data) {
      context.commit('setContacts', data)
    }
  },
  modules: {
    message,
    messagestatus,
    display,
    session,
    group,
    channel,
    conversation
  }
})
